"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldMenuCoreInputs = exports.EmeraldMenuPosition = void 0;
var EmeraldMenuPosition;
(function (EmeraldMenuPosition) {
    EmeraldMenuPosition["fixed"] = "fixed";
    EmeraldMenuPosition["absolute"] = "absolute";
    EmeraldMenuPosition["top_start"] = "top_start";
    EmeraldMenuPosition["top_end"] = "top_end";
    EmeraldMenuPosition["bottom_start"] = "bottom_start";
    EmeraldMenuPosition["bottom_end"] = "bottom_end";
    EmeraldMenuPosition["left_start"] = "left_start";
    EmeraldMenuPosition["left_end"] = "left_end";
    EmeraldMenuPosition["right_start"] = "right_start";
    EmeraldMenuPosition["right_end"] = "right_end";
    EmeraldMenuPosition["left"] = "left";
    EmeraldMenuPosition["auto"] = "auto";
})(EmeraldMenuPosition || (exports.EmeraldMenuPosition = EmeraldMenuPosition = {}));
class EmeraldMenuCoreInputs {
    constructor() {
        this.closeOnOutsideClick = true;
    }
}
exports.EmeraldMenuCoreInputs = EmeraldMenuCoreInputs;
//# sourceMappingURL=menu.inputs.js.map